/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrderLinesDTO } from './CreateOrderLinesDTO';
import {
    CreateOrderLinesDTOFromJSON,
    CreateOrderLinesDTOFromJSONTyped,
    CreateOrderLinesDTOToJSON,
    CreateOrderLinesDTOToJSONTyped,
} from './CreateOrderLinesDTO';

/**
 * 
 * @export
 * @interface CreateOrderDto
 */
export interface CreateOrderDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateOrderDto
     */
    docDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrderDto
     */
    docDueDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    docTotal: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    comments: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    cardCode: string;
    /**
     * 
     * @type {Array<CreateOrderLinesDTO>}
     * @memberof CreateOrderDto
     */
    documentLines: Array<CreateOrderLinesDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    user: string;
}

/**
 * Check if a given object implements the CreateOrderDto interface.
 */
export function instanceOfCreateOrderDto(value: object): value is CreateOrderDto {
    if (!('docDate' in value) || value['docDate'] === undefined) return false;
    if (!('docDueDate' in value) || value['docDueDate'] === undefined) return false;
    if (!('docTotal' in value) || value['docTotal'] === undefined) return false;
    if (!('comments' in value) || value['comments'] === undefined) return false;
    if (!('cardCode' in value) || value['cardCode'] === undefined) return false;
    if (!('documentLines' in value) || value['documentLines'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function CreateOrderDtoFromJSON(json: any): CreateOrderDto {
    return CreateOrderDtoFromJSONTyped(json, false);
}

export function CreateOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'docDate': (new Date(json['docDate'])),
        'docDueDate': (new Date(json['docDueDate'])),
        'docTotal': json['docTotal'],
        'comments': json['comments'],
        'cardCode': json['cardCode'],
        'documentLines': ((json['documentLines'] as Array<any>).map(CreateOrderLinesDTOFromJSON)),
        'user': json['user'],
    };
}

export function CreateOrderDtoToJSON(json: any): CreateOrderDto {
    return CreateOrderDtoToJSONTyped(json, false);
}

export function CreateOrderDtoToJSONTyped(value?: CreateOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'docDate': ((value['docDate']).toISOString()),
        'docDueDate': ((value['docDueDate']).toISOString()),
        'docTotal': value['docTotal'],
        'comments': value['comments'],
        'cardCode': value['cardCode'],
        'documentLines': ((value['documentLines'] as Array<any>).map(CreateOrderLinesDTOToJSON)),
        'user': value['user'],
    };
}

